import gsap from "gsap";

import { debounce } from "./functions";
import { requestScrollTriggerRefresh } from "../base/scroll";

export const isTouchDevice = "ontouchstart" in document.documentElement;
export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
export const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
export let prefersReducedMotion = false;

gsap.matchMedia().add({ reduceMotion: "(prefers-reduced-motion: reduce)" }, context => {
    prefersReducedMotion = !!context.conditions?.reduceMotion;
});

export const inner = {
    w: window.innerWidth,
    h: window.innerHeight,
};

const footer = document.querySelector<HTMLElement>(".footer");

export let varGutter: number = 0;
export let varGap: number = 0;

export function calcResize(triggerScrollRefresh: boolean = true, scope?: HTMLElement) {
    inner.w = window.innerWidth;
    inner.h = window.innerHeight;

    varGutter = convertMaxProp("--gutter");
    varGap = convertMaxProp("--gap");

    const headerScope: ParentNode = scope ?? document;
    const headerEl = headerScope.querySelector<HTMLElement>(".header:not([hidden])");

    calcElHeight(headerEl, "--header-height", scope ?? ":root"); // scope to the container so it doesn't affect the still-visible outgoing page during sync transitions
    calcElHeight(footer, "--footer-height"); // footer lives outside barba containers (single persistent instance), so :root is fine here

    if (triggerScrollRefresh) requestScrollTriggerRefresh(100);
}

export function calcElHeight(el: HTMLElement | null, variableName: string, scope: HTMLElement | ":root" = ":root") {
    if (el) {
        const elHeight = el.offsetHeight;
        gsap.set(scope, { [variableName]: elHeight + "px" });

        return elHeight;
    }
}

function convertMaxProp(maxProp: string) {
    const variable = getComputedStyle(document.documentElement).getPropertyValue(maxProp);

    const [remValue, vwValue] = variable.match(/([\d.]+rem)|([\d.]+vw)/g) ?? ["0rem", "0vw"];

    const remToPixels = (rem: number) => rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
    const vwToPixels = (vw: number) => (vw * window.innerWidth) / 100;

    const remInPixels = remToPixels(parseFloat(remValue));
    const vwInPixels = vwToPixels(parseFloat(vwValue));

    return Math.max(remInPixels, vwInPixels);
}

function resize() {
    if (isTouchDevice) {
        const isSignificantResize = window.innerHeight > inner.h + inner.h * 0.3 || window.innerHeight < inner.h - inner.h * 0.3;
        if (isSignificantResize) calcResize();
    } else calcResize(true);
}

export function initVariables() {
    calcResize(false);
    const debouncedResize = debounce(resize, 300);
    window.addEventListener("resize", debouncedResize);
}
